import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { fetchCategories } from "../../apiCalls/category";
import { ImageUrl } from '../../requestMethods';


const Category = () => {
  const category = useSelector((state) => state.categories.categories);
  const dispatch = useDispatch();

  // navigate("/success", { state: res.data.data });

  // console.log(category, "data from redux");

  useEffect(() => {
    fetchCategories(dispatch);
  }, [dispatch]);

  return (
    <>
      <section className="category">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="category-content has-scrollbar">
                {category.map((catData, index) => {
                  return (
                    <Link to={`/products/${catData?._id}`} className="category-item" key={index}>
                      <div className="category-img-box">
                        <img 
                       src={`${ImageUrl}category/` + catData?.mainImg[0]?.filename}
                       alt={catData.categoryname}
                        />
                      </div>

                      <div className="category-content-box">
                        <div className="category-content-flex">
                          <h3 className="category-item-title">
                            {catData?.categoryname}
                          </h3>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Category;
